module.exports = __webpack_public_path__ + "static/img/14.91975e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/main/14.jpg
// module id = ynP9
// module chunks = 0